import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import EditGamesPage from "./modules/ContentManager/games/EditGamesPage";
import GamesPage from "./modules/ContentManager/games/GamesPage";
import RankingGamesPage from "./modules/ContentManager/games/RankingGamesPage";
import EditGroupsPage from "./modules/ContentManager/groups/EditGroupsPage";
import GroupsPage from "./modules/ContentManager/groups/GroupsPage";
import QuizzesPage from "./modules/ContentManager/quizzes/QuizzesPage";
import EditQuizPage from "./modules/ContentManager/quizzes/EditQuizPage";
import ViewQuizPage from "./modules/ContentManager/quizzes/ViewQuizPage";
import ScenesPage from "./modules/ContentManager/scenes/ScenesPage";
import ViewScenePage from "./modules/ContentManager/scenes/ViewScenePage";
import TextsPage from "./modules/ContentManager/content/TextsPage";
import ImagesPage from "./modules/ContentManager/content/ImagesPage";
import VideosPage from "./modules/ContentManager/content/VideosPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ResultsPage } from "./pages/ResultsPage";

export default function BasePage() {
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);
	const isAdmin = user || user?.role !== "admin";

	return (
		<Switch>
			{/* Redirect from root URL to /dashboard. */}
			<Redirect exact from="/" to="/dashboard" />
			<ContentRoute path="/dashboard" component={DashboardPage} />
			<ContentRoute path="/results" component={ResultsPage} />

			{/* USERS */}
			{/* Administrators */}
			<ContentRoute from="/admins" component={AdminsPage} />
			<ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />

			{/* Groups */}
			<ContentRoute from="/groups" component={GroupsPage} />
			<ContentRoute from="/edit-group/:id?" component={EditGroupsPage} />
			{/* Games */}
			<ContentRoute from="/games" component={GamesPage} />
			<ContentRoute from="/edit-game/:id?" component={EditGamesPage} />
			<ContentRoute
				from="/ranking-game/:id?"
				component={RankingGamesPage}
			/>

			{/* Scenes */}
			<ContentRoute from="/scenarios" component={ScenesPage} />
			<ContentRoute from="/scenario/:id" component={ViewScenePage} />
			{/* Quizzes */}
			<ContentRoute from="/quizzes" component={QuizzesPage} />
			<ContentRoute from="/quiz/:id/edit" component={EditQuizPage} />
			<ContentRoute from="/quiz/:id" component={ViewQuizPage} />

			{/* CONTENT */}
			<ContentRoute from="/content/texts" component={TextsPage} />
			<ContentRoute from="/content/images" component={ImagesPage} />
			<ContentRoute from="/content/videos" component={VideosPage} />

			<Redirect to="/error" />
		</Switch>
	);
}
